import { z } from 'zod';

/**
 * The strict cross-unit projection of an OrganizationsTable read.
 *
 * D-015 P-3 assigns this schema to org-engagement while platform owns only the
 * read grant and Linkable. Consumers parse the legacy flattened record at the
 * adapter boundary so billing, onboarding, and other organization attributes
 * cannot leak across the contract.
 */
export const orgReadSchema = z
  .object({
    organizationId: z.string(),
    organizationName: z.string(),
    defaultPaymentProcessor: z.string(),
    stripeAccountID: z.string(),
    merchantID: z.string(),
    merchantIdentity: z.string(),
    // Compatibility read used by public-api form creation. Absence must remain
    // distinguishable; there is no default and this contract owns no writer.
    doubleTheDonationPublicAPIKey: z.string().optional(),
    // Absence is meaningful in legacy reads: only explicit false means
    // non-exempt. Do not add a default.
    isTaxExempt: z.boolean().optional(),
    // Absence means the Bloomerang integration is off; gates coverFees change
    // detection in subscription_update. Do not add a default.
    bloomerangConnectionEnabled: z.boolean().optional(),
    /** @deprecated → entitlement engine */
    processingPercentFee: z.number(),
    /** @deprecated → entitlement engine */
    processingFixedFee: z.number(),
    /** @deprecated → entitlement engine */
    platformPercentFee: z.number(),
    /** @deprecated → entitlement engine */
    platformFixedFee: z.number(),
  })
  .strict();

export type OrgRead = z.infer<typeof orgReadSchema>;
